$(function () {


    "use strict";
    var SelectedFilterViewOption = "SelectedFilterViewOption";

    $("#ViewMoreSelectedFilters").click(function (e) {
        e.preventDefault();

        ToggleSelectedFiltersView();
    });

    $("#ViewLessSelectedFilters").click(function (e) {
        e.preventDefault();

        ToggleSelectedFiltersView();
    });

    var prodListValues = new productListValues($('#ItemsPerPage').val(), $('#Layout').val(), $('#isUserRegistered').val());
    var debugPath = "";
       ////////
       var selectEvent = (function () {
        var overflow = 10;

        //Pass in false if the filter does not need to be logged
        var markSelected = function (element, logFilter) {
        	if(typeof(logFilter) === 'undefined') logFilter = true;
            element.addClass("selected").find("span[class*='icon-checkMarkBox']").removeClass("textLtGray").addClass("textBlue");
            element.attr("aria-checked", true);
            filterValues.AddFilter(element.prop("id"), logFilter);
            addToSelectedTable(element);

            $("#ClearAllFilters").show();
        }

        var markUnSelected = function (element) {
            element.removeClass("selected").find("span[class*='icon-checkMarkBox']").removeClass("textBlue").addClass("textLtGray");
            element.attr("aria-checked", false);
            filterValues.RemoveFilter(element.prop("id"));
            removeFromSelectedTable(element);
        }

        var setPriceRangeFilter = function (priceMin, priceMax, logFilter) {
            filterValues.RemovePriceRangeFilter();
            removeFromSelectedTable($('#PriceRange'));
            $('#PriceMin').val(priceMin);
            $('#PriceMax').val(priceMax);
            filterValues.AddPriceRangeFilter(priceMin, priceMax, logFilter);
            addToSelectedTable($('#PriceRange'));
            $("#ClearAllFilters").show();
        }

        var clearPriceRangeFilter = function () {
            $('#PriceMin').val(PriceFilter.PriceMinimum.toFixed(2));
            $('#PriceMax').val(PriceFilter.PriceMaximum.toFixed(2));
            filterValues.RemovePriceRangeFilter();
            removeFromSelectedTable($('#PriceRange'));
            $('#price-range > .ui-slider-range').css({ 'left': 0, 'width': '100%' });
            var c = $('#price-range > .ui-slider-handle');
            c.first().css('left', 0).addClass('pointer').append("<span class='visually-hidden'>Minimum price slider</span>");
            c.last().css('left', '100%').addClass('pointer').append("<span class='visually-hidden'>Maximum price slider</span>");
        }
        
        var setSubSearchFilter = function (subSearch, logFilter) {
            filterValues.AddSubSearchFilter(subSearch, logFilter);
            removeFromSelectedTable($('#txtInnerSearch'));
            addToSelectedTable($('#txtInnerSearch'));
            $("#ClearAllFilters").show();
        }

        var clearSubSearchFilter = function () {
            $('#txtInnerSearch').val('');
            filterValues.RemoveSubSearchFilter();
            removeFromSelectedTable($('#txtInnerSearch'));
        }

        var markUnSelectedKeepInTableAndFilter = function (element) {
            element.removeClass("selected").find("span[class*='icon-checkMarkBox']").removeClass("textBlue").addClass("textLtGray").attr("aria-checked", false);
        }

        var markGroupUnSelected = function (list) {
            var elements = list.find("li a[class*='selected']");

            for (var i = 0; i < elements.length; i++) {
                markUnSelected($(elements[i]));
            }
        }

        var markGroupUnSelectedFilter = function (list) {

            for (var i = 0; i < list.length; i++) {
                markUnSelectedKeepInTableAndFilter($("#" + list[i]));
            }
        }

        var addToSelectedTable = function (element) {
            if (element.prop("id") !== filterValues.GetSortElementId(filterValues.GetDefaultSort())) {
                var table = $("#filtersSelected table tbody");
                var rowId = "row_" + element.prop("id");
                var cellId = "cell_" + element.prop("id");
                
                if (element.prop("id") == "PriceRange") {
                    var priceMin = $('#PriceMin').val();
                    var priceMax = $('#PriceMax').val();
                    var row = "<tr id='" + rowId + "'><td class='text18'><span class='icon icon-checkMarkBox paddingRight5 textBlue'></span>Price Range " +
                        priceMin + " &mdash; " + priceMax + "</td><td class='text25 textCenter'><a class='noline' href=''><span id='" + cellId + "' class='icon icon-closeX padding10 textRed'></span>" +
                        "<span class='visually-hidden'>Remove Price Range Filter</span ></a ></td ></tr > ";
                    $("#filtersSelected").removeClass("hide");
                    table.prepend(row);

                    $("#" + cellId).click(function (e) {
                        e.preventDefault();
                        selectEvent.ClearPriceRangeFilter();
                        updateFilterUrl(filterValues, prodListValues, false);
                    });
                }
                else if (element.prop("id") == "txtInnerSearch") {
                    var subSearch = $('#txtInnerSearch').val();
                    var row = "<tr id='" + rowId + "'><td class='text18'><span class='icon icon-checkMarkBox paddingRight5 textBlue'></span>" +
                        "<span>Contains</span><div style=\"max-width: 220px;\"> \"" + subSearch + "\"</div>"  + "</td><td class='text25 textCenter'><a class='noline' href=''><span id='" + cellId + "' class='icon icon-closeX padding10 textRed'></span>" +
                        "<span class='visually-hidden'>Remove Search</span ></a ></td ></tr > ";
                    $("#filtersSelected").removeClass("hide");
                    table.prepend(row);

                    $("#" + cellId).click(function (e) {
                        e.preventDefault();
                        selectEvent.ClearSubSearchFilter();
                        updateFilterUrl(filterValues, prodListValues, false);
                    });
                }
                else {
	                var row = "<tr id='" + rowId + "'><td class='text18'><span class='icon icon-checkMarkBox paddingRight5 textBlue'></span>" +
	                    element.text().trim() + "</td><td class='text25 textCenter'><a class='noline' href=''><span id='" + cellId + "' class='icon icon-closeX padding10 textRed'></span><span class='visually-hidden'>Remove " +
	                    element.text().trim() + " Filter</span></a></td></tr>";
	                $("#filtersSelected").removeClass("hide");
	                table.prepend(row);
	
	                $("#" + cellId).click(function (e) {
	                    e.preventDefault();
	
	                    var element = $(this).prop("id").replace("cell_", "");
	
	                    selectEvent.MarkUnSelected($("#" + element));
	
	                    if (filterValues.IsSortId(element)) {
	                        selectEvent.MarkSelectDefaultSort();
	                    }
	
	                    updateFilterUrl(filterValues, prodListValues, false);
	                });
		   }
		   
                //If there are more than 3 rows(Filters selected) then the Show More or Show Less button needs to be visable
                if ($("#filtersSelected table tbody tr").length > 3) {

                    //Determine which choice was last selected.
                    if ($("#ViewMoreSelectedFilters").hasClass(SelectedFilterViewOption)) {
                        $("#ViewMoreSelectedFilters").show();
                        $("#ViewLessSelectedFilters").hide();
                    }
                    else {
                        $("#ViewLessSelectedFilters").show();
                        $("#ViewMoreSelectedFilters").hide();
                    }
                }
            }
        }

        var removeFromSelectedTable = function (element) {
            $("#filtersSelected #row_" + element.prop("id")).remove();

            if (!$("#filtersSelected table tbody tr").length) {
                $("#filtersSelected").addClass("hide");
            }

            //If there are less than 4 rows(Filters selected) then the Show More and Show Less button needs to be hidden.
            if ($("#filtersSelected table tbody tr").length < 4) {
                $("#ViewMoreSelectedFilters").hide();
                $("#ViewLessSelectedFilters").hide();
            }
        }

        var removeAllFromSelectedTable = function () {
            $("#filtersSelected table tbody").empty();

            $("#filtersSelected").addClass("hide");
            $("#ViewMoreSelectedFilters").hide();
            $("#ViewLessSelectedFilters").hide();
        }

        var unSelectAllFilters = function () {

            var colorFilterValues = filterValues.GetColorFilter();
            var colorValuesWithElementID = [];
            for (var i = 0; i < colorFilterValues.length; i++) {
                colorValuesWithElementID.push(filterValues.getColorElementId(colorFilterValues[i]));
            }

            var ratingFilterValues = filterValues.GetRatingFilter();
            var ratingValuesWithElementID = [];
            for (var i = 0; i < ratingFilterValues.length; i++) {
                ratingValuesWithElementID.push(filterValues.GetRatingElementId(ratingFilterValues[i]));
            }

            var productTimeFilterValues = filterValues.GetProdTimeFilter();
            var productTimeValuesWithElementID = [];
            for (var i = 0; i < productTimeFilterValues.length; i++) {
                productTimeValuesWithElementID.push(filterValues.GetProductionTimeElementId(productTimeFilterValues[i]));
            }

            var tagFilterValues = filterValues.GetTagFilter();
            var tagValuesWithElementID = [];
            for (var i = 0; i < tagFilterValues.length; i++) {
                tagValuesWithElementID.push(filterValues.GetTagElementId(tagFilterValues[i]));
            }

            //Unselect current filtering.
            selectEvent.MarkGroupUnSelectedFilter(colorValuesWithElementID);
            selectEvent.MarkGroupUnSelectedFilter(ratingValuesWithElementID);
            selectEvent.MarkGroupUnSelectedFilter(productTimeValuesWithElementID);
            selectEvent.MarkGroupUnSelectedFilter(tagValuesWithElementID);
            selectEvent.ClearPriceRangeFilter();
            selectEvent.ClearSubSearchFilter();

            //Unselect current sorting.
            var sortFilter = filterValues.GetSortElementId(filterValues.GetSortFilter());
            selectEvent.MarkUnSelectedKeepInTableAndFilter($("#sortMenuMobile ul #" + sortFilter));

            //Remove all filter values.
            filterValues.ClearFilters();

            //Remove all values from the table.
            selectEvent.RemoveAllFromSelectedTable();

            //Mark default sorting as checked.
            selectEvent.MarkSelectDefaultSort();

            //Update the filter url, products and other information.
            updateFilterUrl(filterValues, prodListValues, false);
        }

        var selectMainMenu = function (menu) {
            menu.removeClass("darkestLink").addClass("whiteLink active").attr("aria-expanded", "true");

            $("#" + menu.attr("aria-controls")).removeClass("hide").find("a").filter(":visible:first").focus();

            $("#" + menu.attr("aria-controls")).find("a").filter(":visible:last").keydown(function (e) { tabKeyPress(e, $("#" + menu.attr("aria-controls"))) });

            unSelectMainMenu($("#" + menu.attr("data-disable-id")));
        }

        var unSelectMainMenu = function (menu) {
            menu.removeClass("whiteLink active").addClass("darkestLink").attr("aria-expanded", "false");

            $("#" + menu.attr("data-disable-id")).prop("disabled", false).removeAttr("tabindex");

            $("#" + menu.attr("aria-controls")).find("a").filter(":visible:last").off("keydown");
            $("#" + menu.attr("aria-controls")).addClass("hide");
            $("#menuContainer .filterMenu").addClass("hide");
        }

        var selectFilterMenu = function (menu) {
            menu.removeClass("hide").find("a").filter(":visible:first").focus();

            menu.find("a").filter(":visible:last").keydown(function (e) { tabKeyPress(e, menu) });
            //document.getElementById("txtSearch").scrollIntoView();//Commented out because it was making it hard to use the filtering feature.
        }

        var unSelectFilterMenu = function (element) {
            element.closest("ul").find("a").filter(":visible:last").off("keydown");
            element.closest("div").addClass("hide");
        }

        var markSelectedReload = function (element, currentIds, newIds, getId) {
            var filters = "";

            for (var i = 0; i < newIds.length; i++) {
                if (currentIds.indexOf(newIds[i]) === -1) {
                    filters += "#" + getId(newIds[i]) + ",";
                }
            }

            if (filters.length) {
                var list = element.find(filters.substr(0, filters.length - 1));

                for (var j = 0; j < list.length; j++) {
                    markSelected($(list[j]), false);
                }
            }
        }

        var markUnSelectedReload = function (element, currentIds, newIds, getId, endIndex) {
            var filters = "";

            for (var i = 0; i < endIndex; i++) {
                if (newIds.indexOf(currentIds[i]) === -1) {
                    filters += "#" + getId(currentIds[i]) + ",";
                }
            }

            if (filters.length) {
                var list = element.find(filters.substr(0, filters.length - 1));

                for (var j = 0; j < list.length; j++) {
                    markUnSelected($(list[j]));
                }
            }
        }

        var markSelectDefaultSort = function () {
            // checks if any sort elements are checked and if not checks the default sort element
            if (!$("#" + $("#sortDropDown").attr("aria-controls") + " ul li a[class*='selected']").length) {
                markSelected($("#" + filterValues.GetSortElementId(filterValues.GetSortFilter())), false);
            }
        }

        var updateMenuSelections = function (options) {
            var mainMenu = $("#filterMenuMobile a:not(.moreLink,.noHide)"); 
            var disableMenu = false;
            var mainMenuCnt = 0;
            var hideMain = "";
            var showMain = "";
            var moreMain = "";

            for (var i = 0; i < mainMenu.length; i++) {
                if (updateMenuOptions(mainMenu[i].getAttribute("aria-controls"), options)) {
                    hideMain += "#" + mainMenu[i].id + ",";
                } else {
                    if ((++mainMenuCnt) <= overflow) {
                        showMain += "#" + mainMenu[i].id + ",";
                    } else {
                        moreMain += "#" + mainMenu[i].id + ",";
                    }
                }
            }

            if (hideMain.length) {
                $("#filterMenuMobile").find(hideMain.substr(0, hideMain.length - 1)).parent('li').addClass("hide").removeClass("overflow");
            }

            if (showMain.length) {
                $("#filterMenuMobile").find(showMain.substr(0, showMain.length - 1)).parent("li").removeClass("hide").removeClass("overflow");
            }

            if (moreMain.length) {
                $("#filterMenuMobile").find(moreMain.substr(0, moreMain.length - 1)).parent("li").addClass("hide").addClass("overflow")

                resetMoreLink($("#filterMenuMobile .moreLink"));
            } else {
                $("#filterMenuMobile .moreLink").parent("li").addClass("hide");
            }
        }

        var updateMenuOptions = function (menuId, options) {
            var filters = $("#" + menuId + " a:not(.moreLink,.noHide)"); 
            var optionCnt = 0;

            if (filters.length < 2) {
                return true;
            }

            var filterOptions = options[menuId];
            var selectedOptions = filterValues.GetSelectedFilters(filters[1].id);

            if (!((filterOptions && filterOptions.length) || (selectedOptions && selectedOptions.length))) {
                return true;
            }

            var filterId = "";
            var valid = false;
            var selected = false;
            var hideOption = "";
            var showOption = "";
            var moreOption = "";

            for (var i = 1; i < filters.length; i++) {
                valid = false;
                filterId = filterValues.GetFilterId(filters[i].id);
                if (filterId) {
                    for (var k = 0; k < selectedOptions.length; k++) {
                        if (selectedOptions[k] === filterId) {
                            selected = valid = true;
                            break;
                        }
                    }

                    if (!valid && filterOptions) {
                        for (var j = 0; j < filterOptions.length; j++) {
                            if (filterOptions[j] === filterId) {
                                valid = true;
                                break;
                            }
                        }
                    }

                    if (valid) {
                        if ((++optionCnt) <= overflow) {
                            showOption += "#" + filters[i].id + ",";
                        } else {
                            moreOption += "#" + filters[i].id + ",";
                        }
                    } else {
                        hideOption += "#" + filters[i].id + ",";
                    }
                }
            }

            if (showOption.length && (optionCnt > 1 || selected)) {
                $("#" + menuId)
                    .find(showOption.substr(0, showOption.length - 1))
                    .parent("li")
                    .removeClass("hide")
                    .removeClass("overflow");
            } else {
                return true;
            }

            if (hideOption.length) {
                $("#" + menuId).find(hideOption.substr(0, hideOption.length - 1)).parent("li").addClass("hide").removeClass("overflow");
            }

            if (moreOption.length) {
                $("#" + menuId).find(moreOption.substr(0, moreOption.length - 1)).parent("li").addClass("hide").addClass("overflow");

                resetMoreLink($("#" + menuId + " .moreLink"));
            } else {
                $("#" + menuId + " .moreLink").parent("li").addClass("hide");
            }

            return false;
        }

        var resetMoreLink = function (moreLink) {
            if (moreLink.length) {
                var element = $(moreLink[0])
                element.parent("li").removeClass("hide");

                if (element.attr("aria-expanded") === "true") {
                    var newLabel = element.attr("data-toggle-label");
                    element.attr("data-toggle-label", element.html());
                    element.html(newLabel);
                    element.attr("aria-expanded", "false");
                }
            }
        }

        var tabKeyPress = function (e, menu) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();

                $(menu).find("a").filter(":visible:first").focus();
            }
        }

        return {
            MarkSelected: markSelected,
            MarkUnSelected: markUnSelected,
            MarkUnSelectedKeepInTableAndFilter: markUnSelectedKeepInTableAndFilter,
            MarkGroupUnSelected: markGroupUnSelected,
            MarkGroupUnSelectedFilter: markGroupUnSelectedFilter,
            RemoveAllFromSelectedTable: removeAllFromSelectedTable,
            SelectMainMenu: selectMainMenu,
            UnSelectMainMenu: unSelectMainMenu,
            MarkSelectedReload: markSelectedReload,
            MarkUnSelectedReload: markUnSelectedReload,
            MarkSelectDefaultSort: markSelectDefaultSort,
            UpdateMenuSelections: updateMenuSelections,
            SelectFilterMenu: selectFilterMenu,
            UnSelectFilterMenu: unSelectFilterMenu,
            UnSelectAllFilters: unSelectAllFilters,
            ClearPriceRangeFilter: clearPriceRangeFilter,
            SetPriceRangeFilter: setPriceRangeFilter,
            ClearSubSearchFilter: clearSubSearchFilter,
            SetSubSearchFilter: setSubSearchFilter
        }
    }());
       ////////
    var filterValues = (function () {
        var priceFilter = [],
            colorFilter = [],
            ratingFilter = [],
            prodTimeFilter = [],
            tagFilter = [],
            sortFilter = "",
            pageNumber = 0,
            colorId = "chkColor_",
            ratingId = "chkRating_",
            tagId = "chkTag_",
            prodTimeId = "chkProductionTime_",
            sortId = "chksort_",
            defaultSort = "-RelevenceScore",
            subSearchFilter = "";

        //Pass in false if the filter does not need to be logged .
        var addFilter = function (filterId, logFilter) {
        	if(typeof(logFilter) === 'undefined') logFilter = true;
            if (filterId.indexOf(colorId) === 0) {

                var filterIdValue = filterId.replace(colorId, '');
                colorFilter.push(filterIdValue);

                if (logFilter === true) {
                    filterLog("", "", "Color", filterIdValue);
                }
            }
            else if (filterId.indexOf(ratingId) === 0) {

                var filterIdValue = filterId.replace(ratingId, '');
                ratingFilter.push(filterIdValue);

                if (logFilter === true) {
                    filterLog("", "", "Rating", filterIdValue);
                }
            } else if (filterId.indexOf(prodTimeId) === 0) {

                var filterIdValue = filterId.replace(prodTimeId, '');
                prodTimeFilter.push(filterIdValue);

                if (logFilter === true) {
                    filterLog("", "", "Production Time", filterIdValue);
                }
            } else if (filterId.indexOf(tagId) === 0) {

                var filterIdValue = filterId.replace(tagId, '');
                tagFilter.push(filterIdValue);

                if (logFilter === true) {
                    filterLog("", "", "Tag", filterIdValue);
                }
            } else if (filterId.indexOf(sortId) === 0) {

                sortFilter = filterId.replace(sortId, '');

                if (logFilter === true) {
                    filterLog("", "", "Sort", sortFilter);
                }
            }
        }
        
        var addPriceRangeFilter = function (priceRangeMin, priceRangeMax, logFilter) {
            if (typeof (logFilter) === 'undefined') logFilter = true;
            while (priceFilter.length) {
                priceFilter.shift();
            }

            priceFilter.push(priceRangeMin);
            priceFilter.push(priceRangeMax);
            var filtervalue = priceRangeMin + '-' + priceRangeMax;
            if (logFilter === true) {
                filterLog("", "", "PriceRange", filtervalue);
            }
        }

        var addSubSearchFilter = function (subSearch, logFilter) {
            if (typeof (logFilter) === 'undefined') logFilter = true;
            subSearchFilter = subSearch;
            if (logFilter === true) {
                filterLog("", "", "SubSearch", subSearch);
            }
        }

        var getSelectedFilters = function (filterId) {
            if (filterId.indexOf(colorId) === 0) {
                return getColorFilter();
            } else if (filterId.indexOf(ratingId) === 0) {
                return getRatingFilter();
            } else if (filterId.indexOf(prodTimeId) === 0) {
                return getProdTimeFilter();
            } else if (filterId.indexOf(tagId) === 0) {
                return getTagFilter();
            } else {
                return [];
            }
        }

        var getFilterId = function (filterId) {
            if (filterId.indexOf(colorId) === 0) {
                return filterId.replace(colorId, '');
            } else if (filterId.indexOf(ratingId) === 0) {
                return filterId.replace(ratingId, '');
            } else if (filterId.indexOf(prodTimeId) === 0) {
                return filterId.replace(prodTimeId, '');
            } else if (filterId.indexOf(tagId) === 0) {
                return filterId.replace(tagId, '');
            } else if (filterId.indexOf(sortId) === 0) {
                return filterId.replace(sortId, '');
            }
        }
        var addPageNumber = function (pageNo) {
            pageNumber = pageNo;
        }

        var removeFilter = function (filterId) {
            var index;

            if (filterId.indexOf(colorId) === 0) {
                index = colorFilter.indexOf(filterId.replace(colorId, ''));
                if (index > -1) {
                    colorFilter.splice(index, 1);
                }
            } else if (filterId.indexOf(ratingId) === 0) {
                index = ratingFilter.indexOf(filterId.replace(ratingId, ''));
                if (index > -1) {
                    ratingFilter.splice(index, 1);
                }
            } else if (filterId.indexOf(prodTimeId) === 0) {
                index = prodTimeFilter.indexOf(filterId.replace(prodTimeId, ''));
                if (index > -1) {
                    prodTimeFilter.splice(index, 1);
                }
            } else if (filterId.indexOf(tagId) === 0) {
                index = tagFilter.indexOf(filterId.replace(tagId, ''));
                if (index > -1) {
                    tagFilter.splice(index, 1);
                }
            } else if (filterId.indexOf(sortId) === 0) {
                sortFilter = defaultSort;
            }
        }
        
        var removePriceRangeFilter = function () {
            while (priceFilter.length) {
                priceFilter.shift();
            }
        }
        
        var removeSubSearchFilter = function () {
            subSearchFilter = "";
        }

        var clearFilters = function () {
            pageNumber = 0;
            sortFilter = defaultSort;
		subSearchFilter = ""; 
		
            while (priceFilter.length) {
                priceFilter.shift();
            }
            while (colorFilter.length) {
                colorFilter.shift();
            }
            while (ratingFilter.length) {
                ratingFilter.shift();
            }
            while (prodTimeFilter.length) {
                prodTimeFilter.shift();
            }
            while (tagFilter.length) {
                tagFilter.shift();
            }
        }

        var getColorElementId = function (color) {
            return colorId + color;
        }

        var getRatingElementId = function (rating) {
            return ratingId + rating;
        }

        var getProductionTimeElementId = function (time) {
            return prodTimeId + time;
        }

        var getTagElementId = function (tag) {
            return tagId + tag;
        }

        var getSortElementId = function (sort) {
            return sortId + sort;
        }

        var getPriceFilter = function () {
            return priceFilter;
        }

        var getColorFilter = function () {
            return colorFilter;
        }

        var getRatingFilter = function () {
            return ratingFilter;
        }

        var getProdTimeFilter = function () {
            return prodTimeFilter;
        }

        var getTagFilter = function () {
            return tagFilter;
        }

        var getSortFilter = function () {
            return sortFilter;
        }

        var getPageNumber = function () {
            return pageNumber;
        }

        var getDefaultSort = function () {
            return defaultSort;
        }
        
        var getSubSearchFilter = function () {
            return subSearchFilter;
        }

        var isSortId = function (filterId) {
            return (filterId.indexOf(sortId) === 0);
        }
        return {
            AddFilter: addFilter,
            AddPriceRangeFilter: addPriceRangeFilter,
            AddSubSearchFilter: addSubSearchFilter, 
            ClearFilters: clearFilters,
            RemoveFilter: removeFilter,
            RemovePriceRangeFilter: removePriceRangeFilter,
            RemoveSubSearchFilter: removeSubSearchFilter,
            AddPageNumber: addPageNumber,
            GetPriceFilter: getPriceFilter,
            GetColorFilter: getColorFilter,
            GetRatingFilter: getRatingFilter,
            GetProdTimeFilter: getProdTimeFilter,
            GetTagFilter: getTagFilter,
            GetSortFilter: getSortFilter,
            GetDefaultSort: getDefaultSort,
            GetPageNumber: getPageNumber,
            getColorElementId: getColorElementId,
            GetRatingElementId: getRatingElementId,
            GetSortElementId: getSortElementId,
            GetProductionTimeElementId: getProductionTimeElementId,
            GetTagElementId: getTagElementId,
            GetSelectedFilters: getSelectedFilters,
            GetFilterId: getFilterId,
            GetSubSearchFilter: getSubSearchFilter,
            IsSortId: isSortId
        }
    }());

$("#ClearAllFilters").click(function (e) {
        e.preventDefault();
        //console.log("clear all filters click");

        selectEvent.UnSelectAllFilters();
        $("#ClearAllFilters").hide();
    });

    $(".filterDropDownMobile").click(function (e) {
        e.preventDefault();

        var element = $(this);

        if (element.prop("disabled")) {
            return;
        }

        if (element.hasClass("active")) {
            selectEvent.UnSelectMainMenu(element);
            element.focus();
            //updateFilterUrl(filterValues, prodListValues);
        } else {
            selectEvent.SelectMainMenu(element)
        }
    });

    $("#menuContainer .filterMenuSelect").click(function (e) {
        e.preventDefault();

        selectEvent.UnSelectFilterMenu($(this));
        selectEvent.SelectFilterMenu($("#" + $(this).attr("aria-controls")));
    });

    $("#menuContainer .moreLink").click(function (e) {
        e.preventDefault();

        var element = $(this);

        var newLabel = element.attr("data-toggle-label");
        element.attr("data-toggle-label", element.html());
        element.html(newLabel);

        if (element.attr("aria-expanded") === "true") {
            element.closest("ul").find("li[class*='overflow']").addClass("hide");
            element.attr("aria-expanded", "false");
            //document.getElementById("txtSearch").scrollIntoView();//Commented out because it was making it hard to use the filtering feature.
        } else {
            element.closest("ul")
                .find("li[class*='overflow']")
                .removeClass("hide");

            element.closest("ul")
                .find("li[class*='overflow'] a")
                .filter(":visible:first")
                .focus();

            element.attr("aria-expanded", "true");
        }
    });

    $("#menuContainer .multiSelect").click(function (e) {
        e.preventDefault();

        var element = $(this);

        if (element.hasClass("selected")) {
            selectEvent.MarkUnSelected(element);
        } else {
            selectEvent.MarkSelected(element);
        }

        $("#filterDropDown").click();
        updateFilterUrl(filterValues, prodListValues, false);
    });

    $("#menuContainer .singleSelect").click(function (e) {
        e.preventDefault();

        var element = $(this);

        if (element.hasClass("selected")) {
            selectEvent.MarkUnSelected(element);
        } else {
            var list = element.closest("ul").find("li a[class*='selected']");
            var el;

            for (var i = 0; i < list.length; i++) {
                el = $(list[i]);

                selectEvent.MarkUnSelected(el);
            }

            selectEvent.MarkSelected(element);
        }

        if (filterValues.IsSortId(element.prop("id"))) {
            selectEvent.MarkSelectDefaultSort();

            $("#sortDropDown").click();
        } else {
            $("#filterDropDown").click();
        }
        updateFilterUrl(filterValues, prodListValues, false);
    });
    
    $("#menuContainer .filterPriceApply").click(function (e) {
        e.preventDefault();

        var priceMin = $('#PriceMin').val();
        var priceMax = $('#PriceMax').val();

	 var parsedMin = parseFloat(priceMin);///^(\d+(\.\d{1,2})?|\.\d{1,2})$/.test(priceMin);
        var parsedMax = parseFloat(priceMax);///^(\d+(\.\d{1,2})?|\.\d{1,2})$/.test(priceMax);

        //validating user input
        if ( isNaN(parsedMin) || isNaN(parsedMax) || parsedMin > parsedMax ) {
            $('#PriceMin').val('');
            $('#PriceMax').val('');
            return;
        }

        selectEvent.SetPriceRangeFilter(parsedMin.toFixed(2), parsedMax.toFixed(2));

        $("#filterDropDown").click();

        updateFilterUrl(filterValues, prodListValues, false);
    });
    
    var setSubSearchClickEvent = function() {
	    $("#pnlSubSearch .subSearch").click(function (e) {
	        e.preventDefault();
		 //console.log('sub search');
	        var subSearch = $('#txtInnerSearch').val();
	        
	        if (subSearch.length == 0) {
	            selectEvent.ClearSubSearchFilter();
	        }
	        else {
	            selectEvent.SetSubSearchFilter(subSearch);
	        }
	        updateFilterUrl(filterValues, prodListValues, false);
	        $('#txtInnerSearch').val('');
	    });
	}
    setSubSearchClickEvent();
    
    //$(".pagerLink").click(function (e) {
    $('#productContainer').on('click', '.pagerLink', function (e) {
        e.preventDefault();
        var pageNo = $(this).attr("data-page-number");

        if (!isNaN(pageNo)) {
           $('body, html').animate({
                scrollTop: $("#mainContent").offset().top
	     }, 700);

            filterValues.AddPageNumber(pageNo);
            updateFilterUrl(filterValues, prodListValues, true);
        }
    });

    $("#a_priceRangeFilter").click(function () {
        //values in the price range filter may have 
        //been changed but not applied...
        //make sure we have the applied values loaded
        var prices = filterValues.GetPriceFilter();
        var priceMin = PriceFilter.PriceMinimum;
        var priceMax = PriceFilter.PriceMaximum;
        if (prices.length == 2) {
            priceMin = prices[0];
            priceMax = prices[1];
        }

        $('#PriceMin').val(priceMin);
        $('#PriceMax').val(priceMax);
        PriceFilter.SliderValues = [priceMin, priceMax];
        $('#price-range').slider('option','animate', false);
        $("#price-range").slider('values', 0, priceMin);
        $("#price-range").slider('values', 1, priceMax);
        $('#price-range').slider('option','animate', true);
    });

    var updateFilterUrl = function (filterValues, prodListValues, updatePageNumber, updateUrl, forceGetProducts) {
    	 if(typeof(updateUrl) === 'undefined') updateUrl = true;
    	 if(typeof(forceGetProducts) === 'undefined') forceGetProducts = false;
        //console.log("updateFilterUrl");
        var newPath = UrlPath()
        + UpdatedPriceFilterRouteParam(filterValues.GetPriceFilter())
        + UpdatedColorFilterRouteParam(filterValues.GetColorFilter())
        + UpdatedRatingFilterRouteParam(filterValues.GetRatingFilter())
                    + UpdatedProdTimeRouteParam(filterValues.GetProdTimeFilter())
                    + UpdatedTagFilterRouteParam(filterValues.GetTagFilter());
        //+ UpdatedFilterQueryString(filterValues.GetPageNumber(), prodListValues.SortMap, filterValues.GetSortFilter());

        //TO DO what happens if one is undefined?
        if (filterValues.GetColorFilter().length == 0 && filterValues.GetRatingFilter().length == 0 && filterValues.GetProdTimeFilter().length == 0 && filterValues.GetTagFilter().length == 0 && 
            filterValues.GetPriceFilter().length == 0 && filterValues.GetSubSearchFilter().length == 0) { 
            //console.log("a length is zero");
            $("#ClearAllFilters").hide();
        }

        //If the paging is applied update the page number. If filtering or sorting is applied then set the page to the beginning.
        if (updatePageNumber === true) {
            newPath += UpdatedFilterQueryString(filterValues.GetPageNumber(), prodListValues.SortMap, filterValues.GetSortFilter(),filterValues.GetSubSearchFilter());
        }
        else {
            newPath += UpdatedFilterQueryString(1, prodListValues.SortMap, filterValues.GetSortFilter(), filterValues.GetSubSearchFilter());
        }

        if (!forceGetProducts && window.location.pathname + window.location.search === debugPath + newPath) {
            return;
        }

        // do jquery call here
        getProducts(newPath, updateUrl, debugPath + newPath);

        //prodListValues.ReplaceCurrentUrl(debugPath + newPath, $('#BaseTitle').val(), $('#BaseDescription').val(), $('#BaseKeywords').val());
        //        prodListValues.ReplaceCurrentMobileUrl(debugPath + newPath, $('#BaseTitle').val(), $('#BaseDescription').val(), $('#BaseKeywords').val());//TODO this may need to be called only after getProducts ajax completes


        function UpdatedPriceFilterRouteParam(priceRange) {
            var priceFilter = '';

            if (priceRange.length > 1) {
                var priceMin = priceRange[0];
                var priceMax = priceRange[1];
                priceFilter = '/p/' + (priceMin * 100).toFixed() + '-' + (priceMax * 100).toFixed();
            }

            return priceFilter;
        }

        function UpdatedColorFilterRouteParam(colors) {
            var colorFilters = "";
            if (colors.length) {
                colorFilters = '/c/' + colors.join('-');
            }
            return colorFilters;
        }

        function UpdatedRatingFilterRouteParam(ratings) {
            var ratingFilters = "";
            if (ratings.length) {
                ratingFilters = '/r/' + ratings.join('-');
            }
            return ratingFilters;
        }

        function UpdatedProdTimeRouteParam(prodTimes) {
            var timeFilter = "";
            if (prodTimes.length) {
                timeFilter = '/s/' + prodTimes.join('-');
            }
            return timeFilter;
        }

        function UpdatedTagFilterRouteParam(tags) {
            var tagFilter = "";

            if (tags.length) {
                tagFilter = '/t/' + tags.join('-');
            }
            return tagFilter;
        }
        
        //needed to remove any page values from querystring after filter update
        function UpdatedFilterQueryString(pageNo, sortMap, sort, subSearch) {
            var newQueryString = "?";

            if (pageNo) {
                newQueryString += "page=" + pageNo + "&";
            }

            if (sort) {
                for (var i = 0; i < sortMap.length; i++) {
                    if (sortMap[i].v.search(sort) > -1) {
                        newQueryString += sortMap[i].q + "&";
                        break;
                    }
                }
            }
            
            if (subSearch) {
                newQueryString += 'ss=' + subSearch + '&';
            }

            //var currentUrl = window.location.href;
            //var matches = prodListValues.SubSearchPattern.exec(currentUrl);
            //if (matches !== null) {
            //	newQueryString = '?' + matches[0];
            //}
            //matches = prodListValues.ItemsPerPagePattern.exec(currentUrl);
            //if (matches !== null) {
            //	if (newQueryString === '') {
            //		newQueryString = '?' + matches[0];
            //	} else {
            //		newQueryString = newQueryString + '&' + matches[0];
            //	}
            //}
            //if ($('#aSearchQueryUrl').val().trim().length > 0) {
            //	if (newQueryString === '') {
            //		newQueryString = '?' + $('#aSearchQueryUrl').val();
            //	} else {
            //		newQueryString = newQueryString + '&' + $('#aSearchQueryUrl').val();
            //	}
            //}
            return newQueryString.substr(0, newQueryString.length - 1);
        }

	  function UrlPath() {
            var currentUrl = window.location.href;
            var baseUrl = '';
            var paramPattern = /\/[cprst]\/[0-9]/;
            var matches = paramPattern.exec(currentUrl);

            if ($('#FilterFriendlyUrl').val().length > 0) {
                baseUrl = $('#FilterFriendlyUrl').val();
            }
            else if (matches != null) {
                baseUrl = currentUrl.slice(0, matches.index);
            }
            else if (currentUrl.indexOf('?') >= 0) {
                baseUrl = currentUrl.slice(0, currentUrl.indexOf('?'));
            }
            else {
                baseUrl = currentUrl;
            }
            var urlArray = currentUrl.split('/');
            var prot = urlArray[0];
            var host = urlArray[2];
            var url = prot + '//' + host;
            return baseUrl.replace(url, '');
        }

    }

    // need to verify this is needed and utilize prodListValues.ReplaceCurrentUrl?
    function initializeState() {
        var loc = window.location.href;
        var title = document.title;
        var keywords = $('meta[name="keywords"]').attr('content');
        var description = $('meta[name="description"]').attr('content');
        var urlArray = loc.split('/');
        var prot = urlArray[0];
        var host = urlArray[2];
        var url = prot + '//' + host;
        history.replaceState({ title: title, keywords: keywords, description: description }, '', loc);
        
        updatePageFromUrl();
        
        ParsePriceFilters($("#PriceMin"), $("#PriceMax"));
        SetupPriceSlider($("#price-range"), $("#PriceMin"), $("#PriceMax"));
        SetPriceKeyUp($("#price-range"), $("#PriceMin"), $("#PriceMax"));
    }


    window.onpopstate = function (event) {
        var current = window.location.href;


        if (event.state != null) {
            document.title = event.state.title;
            $('meta[name="keywords"]').attr('content', event.state.keywords);
            $('meta[name="description"]').attr('content', event.state.description);
        }
        else {
            document.title = "";
            $('meta[name="keywords"]').attr('content', "");
            $('meta[name="description"]').attr('content', "");
        }

        var menus = $(".filterDropDownMobile[class*='active']");

        for (var i = 0; i < menus.length; i++) {
            selectEvent.UnSelectMainMenu($(menus[i]));
        }

        updatePageFromUrl();

        // do ajax call
        //getProducts(current.replace(window.location.origin + debugPath, ''), false, "");
        //updateFilterUrl(filterValues, prodListValues, false, false, true);
        updateFilterUrl(filterValues, prodListValues, true, false, true);
    }

    //set values from RouteData and QueryString
    var updatePageFromUrl = function () {
        //console.log("updatePageFromUrl");
        var currentUrl = window.location.href;
        //filterValues.ClearFilters();   //clear filterList

        var filterCnt = setColorFilter() +
            setRatingFilter() +
            setProductionTimeFilter() +
            setTagFilter() + 
            setPriceRangeFilter() +
            setSubSearch();

        setPageNumber();
        setSortOrder();

        //If there are no filters applied make sure that the clear all filters option is not visible.
        if (filterCnt == 0) {
            $("#ClearAllFilters").hide();
        }

        function setPriceRangeFilter() {
            var matches = prodListValues.PricePattern.exec(currentUrl);
            var amounts = [];
            
            selectEvent.ClearPriceRangeFilter();

            if (matches) {
                var vals = matches[0].split('/');
                if (vals.length >= 3) {
                    $.merge(amounts, vals[2].split('-'));
                    
                     if (isNaN(parseFloat(amounts[0])) || isNaN(parseFloat(amounts[1]))){
                        return 0;
                    }

                    var priceMin = (amounts[0] / 100);
                    var priceMax = (amounts[1] / 100);

			PriceFilter.SliderValues = [priceMin, priceMax];

                    selectEvent.SetPriceRangeFilter(priceMin.toFixed(2), priceMax.toFixed(2));
                }
            }

            return filterValues.GetPriceFilter().length;
        }

        function setColorFilter() {
            /* set color filters from url */
            var matches = prodListValues.ColorPattern.exec(currentUrl);
            var colorList = $("#colorFilter ul");
            var ids = [];
            var startLen = filterValues.GetColorFilter().length;

            //selectEvent.MarkGroupUnSelected(colorList);

            if (matches) {
                var vals = matches[0].split('/');

                if (vals.length >= 3) {
                    $.merge(ids, vals[2].split('-'));

                    selectEvent.MarkSelectedReload(colorList, filterValues.GetColorFilter(), ids, filterValues.getColorElementId);
                }
            }

            selectEvent.MarkUnSelectedReload(colorList, filterValues.GetColorFilter(), ids, filterValues.getColorElementId, startLen);

            return filterValues.GetColorFilter().length;
        }

        function setRatingFilter() {
            /* set rating filter from url */
            var matches = prodListValues.RatingPattern.exec(currentUrl);
            var ratingList = $("#ratingFilter ul");
            var ids = [];
            var startLen = filterValues.GetRatingFilter().length;

            //selectEvent.MarkGroupUnSelected(ratingList);

            if (matches !== null) {
                var vals = matches[0].split('/');

                if (vals.length >= 3) {
                    $.merge(ids, vals[2].split('-'));

                    selectEvent.MarkSelectedReload(ratingList, filterValues.GetRatingFilter(), ids, filterValues.GetRatingElementId);
                }
            }
            selectEvent.MarkUnSelectedReload(ratingList, filterValues.GetRatingFilter(), ids, filterValues.GetRatingElementId, startLen);

            return filterValues.GetRatingFilter().length;
        }

        function setProductionTimeFilter() {
            /* set production time filter from url */
            var matches = prodListValues.ProdTimePattern.exec(currentUrl);
            var timeList = $("#productionTimeFilter");
            var ids = [];
            var startLen = filterValues.GetProdTimeFilter().length;

            //selectEvent.MarkGroupUnSelected(timeList);

            if (matches !== null) {
                var vals = matches[0].split('/');

                if (vals.length >= 3) {
                    $.merge(ids, vals[2].split('-'));

                    selectEvent.MarkSelectedReload(timeList, filterValues.GetProdTimeFilter(), ids, filterValues.GetProductionTimeElementId);
                }
            }
            selectEvent.MarkUnSelectedReload(timeList, filterValues.GetProdTimeFilter(), ids, filterValues.GetProductionTimeElementId, startLen);

            return filterValues.GetProdTimeFilter().length;
        }

        function setPageNumber() {
            /* set page number from url */
            var matches = prodListValues.PagePattern.exec(currentUrl);
            if (matches !== null) {
                var vals = matches[0].split('=');

                if (vals.length >= 2) {
                    filterValues.AddPageNumber(vals[1])
                }
            }
        }
        
        function setSubSearch() {
            var matches = prodListValues.SubSearchPattern.exec(currentUrl);
            selectEvent.ClearSubSearchFilter();
            if (matches != null) {
                var vals = matches[0].split('=');

                if (vals.length >= 2) {
                    var subSearchFilter = unescape(vals[1]);
                    $('#txtInnerSearch').val(subSearchFilter);
                    selectEvent.SetSubSearchFilter(subSearchFilter);
                    $('#txtInnerSearch').val('');
                    return 1;
                }
            }

            return 0;
        }

        function setSortOrder() {
            /* set filter order from url*/
            var matches = prodListValues.SortByPattern.exec(currentUrl);
            var sort = filterValues.GetDefaultSort();

            if (matches) {
                for (var i = 0; i < prodListValues.SortMap.length; i++) {
                    if (prodListValues.SortMap[i].q === matches[0]) {
                        sort = prodListValues.SortMap[i].v.replace("string:", "");
                        break;
                    }
                }
            }

            if (sort !== filterValues.GetSortFilter()) {
                var sortFilter;

                if (filterValues.GetSortFilter()) {
                    sortFilter = filterValues.GetSortElementId(filterValues.GetSortFilter());
                    selectEvent.MarkUnSelected($("#sortMenuMobile ul #" + sortFilter));
                }

                sortFilter = filterValues.GetSortElementId(sort);
                selectEvent.MarkSelected($("#sortMenuMobile ul #" + sortFilter), false);
            }
        }

        function setTagFilter() {
            /* set tag filters from url */
            var matches = prodListValues.TagPattern.exec(currentUrl);
            var tagList = $("#tagFilter ul");
            var ids = [];
            var startLen = filterValues.GetTagFilter().length;
            var defaultTag = checkCustomUrl();

            //selectEvent.MarkGroupUnSelected(tagList);

            if (matches) {
                var vals = matches[0].split('/');

                if (vals.length >= 3) {
                    $.merge(ids, vals[2].split('-'));
                }
            }

            if (defaultTag.length) {
                $.merge(ids, defaultTag.split('-'));
            }

            selectEvent.MarkSelectedReload(tagList, filterValues.GetTagFilter(), ids, filterValues.GetTagElementId);
            selectEvent.MarkUnSelectedReload(tagList, filterValues.GetTagFilter(), ids, filterValues.GetTagElementId, startLen);

            return filterValues.GetTagFilter().length;
        }

        function checkCustomUrl() {
            /*set values for rewriten urls (i.e. 'athletic-tshirts' is 'tag/97/t/4531' */
            var defaultTag = $("#rewriteDefaultTag").val();
            var urlVals = currentUrl.split('/');
            var urlVals2 = urlVals[3].split('?');
            if ($('#filterRewrite').val() === "") {
                if (defaultTag !== "" && currentUrl.indexOf($('#FilterFriendlyUrl').val()) === -1) {
                    var vals = currentUrl.split('/');
                    $('#filterRewrite').val(urlVals2[0]);
                } else {
                    defaultTag = "";
                    $("#rewriteDefaultTag").val('');
                }
            } else if (urlVals2[0] !== $('#filterRewrite').val()) {
                defaultTag = "";
            }

            return defaultTag;
        }
    }



    var getProducts = function (path, updateUrl, newPathToUse) {

        $('#loadingItems').show();
        $('#productListMain').addClass('transparent');
        $.ajax({
            url: "/List/Filter" + path,
            type: "GET",
            dataType: "json",
            contentType: "application/json",
            success: function (result) {

                //Update the filter menu with new filters.
                selectEvent.UpdateMenuSelections(JSON.parse(result.HtmlString));

                //Update with the new filter results.
                $('#productContainer').html(result.UpdatedProducts);
                
                setSubSearchClickEvent();
            },
            error: function (result) {
                //TODO: display error message to user
                console.log(result.responseText);
            },
            complete: function (result) {
                $('#loadingItems').hide();
                $('#productListMain').removeClass('transparent');

                if (updateUrl === true) {
                    prodListValues.ReplaceCurrentMobileUrl(newPathToUse, $('#BaseTitle').val(), $('#BaseDescription').val(), $('#BaseKeywords').val());
                }
            }
        });

        return;
    }

    initializeState();


    function filterLog(pagetype, pagevalue, filtertype, filtervalue) {
        //Log in Omniture.
        if (typeof s != "undefined") {
            s.prop18 = filtertype + " : " + filtervalue;//List Filter prop
            s.prop19 = filtertype;//List Filter Group prop
            s.eVar30 = s.prop18;//List Filter event variable expires at hit
            s.eVar32 = s.prop18;//List Filter event variable expires at order
            //s.events = '';//No event set up in SC for filtering
            pagetype = s.prop12;
            if (s.prop12 === "Search") {
                pagevalue = s.prop1;
            }//internal search prop 
            else {
                pagevalue = s.prop7;
            } //groupname, taggroupname, or storename }
            var s_code = s.t(); if (s_code) document.write(s_code);
        }
        
        if (typeof pagetype === 'undefined'){
        	pagetype = "";
        }
        
        if (typeof pagevalue === 'undefined'){
        	pagevalue = "";
        }
        
        if (typeof filtertype === 'undefined'){
        	filtertype = "";
        }
        
        if (typeof filtervalue === 'undefined'){
        	filtervalue = "";
        }
	
        var filterData = {
            pagetype: pagetype,
            pagevalue: pagevalue,
            filtertype: filtertype,
            filtervalue: filtervalue
        }

        $.ajax({
            url: "/filters/logFilterToCache",
            type: "POST",
            data: filterData,
            dataType: "json",
            success: function (result) {
                //console.log("success");
            },
            error: function (result) {
                //console.log("error");
            }
        });
    }

    //Toggle the view more and less selected filters visability and CSS to change the display.
    function ToggleSelectedFiltersView() {
        $("#filtersSelected").toggleClass("ViewLessSelectedFilters");
        $("#ViewMoreSelectedFilters").toggleClass(SelectedFilterViewOption);
        $("#ViewLessSelectedFilters").toggleClass(SelectedFilterViewOption);
        $("#ViewMoreSelectedFilters").toggle();
        $("#ViewLessSelectedFilters").toggle();
    }
    
    function ParsePriceFilters(PriceMinObject, PriceMaxObject) {
        PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum));
        PriceMaxObject.val(parseFloat(PriceFilter.PriceMaximum));
    }

    function SetPriceKeyUp(SliderObject, PriceMinObject, PriceMaxObject) {
        PriceMinObject.on('blur', function () {
            if ($.isNumeric(PriceMinObject.val())) {
                var min = PriceMinObject.val();
                var max = PriceMaxObject.val();

                if (min < parseFloat(PriceFilter.PriceMinimum)) {
                    PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum));
                }

                if (parseFloat(min) > parseFloat(max)) {
                    PriceMinObject.val(max);
                }

                SliderObject.slider("values", 0, PriceMinObject.val());
            } else {
                PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum).toFixed(2));
            }
        });
        
        SliderObject.keyup(function () {
            if ($.isNumeric(PriceMinObject.val())) {
                var min = PriceMinObject.val();
                var max = PriceMaxObject.val();

                if (min < parseFloat(PriceFilter.PriceMinimum)) {
                    PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum));
                }

                if (parseFloat(min) > parseFloat(max)) {
                    PriceMinObject.val(max);
                }

                SliderObject.slider("values", 0, PriceMinObject.val());
            } else {
                PriceMinObject.val(parseFloat(PriceFilter.PriceMinimum).toFixed(2));
            }
        });

        PriceMaxObject.on('blur', function () {
            if ($.isNumeric(PriceMaxObject.val())) {
                var min = PriceMinObject.val();
                var max = PriceMaxObject.val();

                if (max > parseFloat(PriceFilter.PriceMaximum)) {
                    PriceMaxObject.val(parseFloat(PriceFilter.PriceMaximum));
                }

                if (parseFloat(min) > parseFloat(max)) {
                    PriceMaxObject.val(min);
                }

                SliderObject.slider("values", 1, PriceMaxObject.val());
            } else {
                PriceMaxObject.val(parseFloat(PriceFilter.PriceMaximum).toFixed(2));
            }
        });

    }//end SetPriceKeyUp

    
    function SetupPriceSlider(SliderObject, PriceMinObject, PriceMaxObject) {
        SliderObject.slider({
            range: true,
            animate: true,
            min: PriceFilter.PriceMinimum,
            max: PriceFilter.PriceMaximum,
            step: PriceFilter.SliderStep,
            values: PriceFilter.SliderValues,
            slide: function (event, ui) {
                if (ui.value.toFixed(2) == ui.values[0].toFixed(2)) {
                    PriceMinObject.val(ui.values[0].toFixed(2));
                }
                else {
                    PriceMaxObject.val(ui.values[1].toFixed(2));
                }
                setTimeout(function () {
                }, 200);
            }
        });


        if (SliderObject.length > 0) {
            PriceMinObject.val(SliderObject.slider("values", 0).toFixed(2));
            PriceMaxObject.val(SliderObject.slider("values", 1).toFixed(2));
        }
    }//end SetupPriceSlider
    
});